export const tableRangeSettings = {
	drawer: {
		title: "intervalo de mesas",
	},
	header: {
		filter: {
			optionAllLabel: "Mostrar todos",
			label: "Filtrar por bar",
			placeholder: "Seleccione o busque el bar deseado",
		},
		addBtn: "Agregar intervalo de mesas",
	},
	card: {
		title: "Mesas {{from}} a {{to}}",
		barsLabel: "Impresión en los bares",
	},
	form: {
		status: {
			errors: {
				description:
					"No fue posible agregar el intervalo de mesas informado. Verifique si no hay repetición de alguna mesa cuya configuración de impresión ya haya sido hecha anteriormente.",
				title: "Ups... Algo no salió como planeado.",
			},
			success: {
				titleEditing: "Edición de intervalo de mesas guardada.",
				titleCreating: "¡Intervalo de mesas configurado con éxito!",
			},
		},
		generalWrapperLabel: "Intervalo {{number}}",
		intervalWrapperLabel: "Intervalo de mesas",
		bars: {
			label: "Bares que imprimirán los pedidos de las mesas arriba",
			placeholder: "Busque por nombre",
			selectedBars_one: "{{count}} bar seleccionado",
			selectedBars_other: "{{count}} bares seleccionados",
		},
		removeIntervalBtn: "Eliminar intervalo",
		editingWarningTooltip: "No es posible agregar nuevos intervalos en modo edición.",
		addIntervalBtn: "Agregar otro intervalo",
		errors: {
			atLeastOneBar: "Seleccione al menos un bar para impresión (intervalo {{number}})",
			missingFromTable: "Ingrese el número de la mesa inicial (intervalo {{number}})",
			missingToTable: "Ingrese el número de la mesa final (intervalo {{number}})",
			fromTableAlreadyUsed:
				"Número de la mesa inicial ya utilizado (intervalo {{number}})",
			toTableAlreadyUsed: "Número de la mesa final ya utilizado (intervalo {{number}})",
		},
	},
	deleteModal: {
		title: "Eliminar intervalo de mesas",
		message:
			"¿Desea eliminar la configuración de impresión del intervalo de mesas {{from}} a {{to}}? Al completar esta acción perderá los datos almacenados y no tendrá cómo recuperarlos.",
	},
	tabs: {
		generalSettings: "Configuración general",
		printByTableSettings: "Configurar impresión por mesa",
	},
};
